export default __webpack_public_path__ + "static/O0244-f812b181a3ca5808ff01f9e3efe7944c.png";